import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/firebase'; // Initialize Firebase Analytics
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store, persistedStore } from './redux/store/index';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistedStore}>
      {/* <React.StrictMode> */}
        <App />
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
